<template>
<div class="search">
  <div id="protocol-search">
  <span class="search">
    <input @keyup.enter="submitQuery()" type="text" name="protocol-search" placeholder="Search For Protocols" v-model="query" />
    <button @click="submitQuery()" :disabled="query =='' "></button>
    </span>
  </div>
</div>
</template>

<script>
  import { scrubMixin } from '../mixins'
  export default {
    name: 'SearchBar',
    mixins: [scrubMixin()],
    data: function () {
      return {
        query: '',
        selected: 'all-categories'
      }
    },
    methods: {
      category () {
        return Object.keys(this.$store.state.categories)
      },
      submitQuery () {
        this.$router.push({name: 'search-query', query: {q: this.query}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SearchBar.vue?677e1073